module.exports = __webpack_public_path__ + "pc/img/right-arrow.e8346a9a.svg";